import { render, staticRenderFns } from "./single-message-display.vue?vue&type=template&id=1188c96f&"
import script from "./single-message-display.vue?vue&type=script&lang=js&"
export * from "./single-message-display.vue?vue&type=script&lang=js&"
import style0 from "./single-message-display.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports